queue_hidden = false

playSound = ->
  document.getElementById("idAudio").play()
  false


checkStartRides = ->

  # projde jizdy ve fronte a pokud ma nejak uz ted cas, zazvoni a zmeni jeji status
  console.log 'prochazim jizdy ve fronte'
  dt = new Date();

  hours = dt.getHours();
  minutes = dt.getMinutes();
  if hours < 10
    hours = '0' + hours
  else 
    hours = '' + hours

  if minutes < 10
    minutes = '0' + minutes
  else 
    minutes = '' + minutes

  now = hours + ':' + minutes;

  console.log 'prave je:' + now
  $('#ride_queue .ride').each ->
    if $(@).data('reminder') == now
      $(@).addClass 'important'
      showRideQueue()   

showRideQueue = ->
  queue = $('#ride_queue')
  $('#inner_ride_queue_container').addClass('shown')

  playSound()

  queue.animate
    bottom: '0'
  , 'slow'

hideRideQueue = ->
  queue_hidden = true
  queue = $('#ride_queue')
  inner_height = $('#inner_ride_queue_container').height()
  $('#inner_ride_queue_container').removeClass('shown')
  queue.animate
    bottom: '-' + inner_height + 'px'
  , 'slow'

reloadRideQueue = ->
  $.ajax(
      url: '/ajax/reload_ride_queue.script'
      type: 'POST'
      dataType: 'JSON'
      data:  
          user: $('#user').val()
          
  ).done((data) ->
      console.log data

      last_num = parseInt($('#queue_badge').text())

      new_num = parseInt(data.queue_count)

      console.log last_num, new_num

      if last_num < new_num
        queue_hidden = false
        console.log 'some new rides'

      $('#ride_queue #inner_ride_queue_container').html ''
      $('#ride_queue #inner_ride_queue_container').html data.html_output
      $('#queue_badge').text(data.queue_count)
      if data.queue_count == 0 || !data.queue_count
        $('#queue_badge').text('0').addClass('hidden')
      else 
        $('#queue_badge').removeClass('hidden')

      # ukazujem ridequeue jen kdyz tam je nejaka novinka
      

      if !queue_hidden
        showRideQueue()
      else
        if !$('#inner_ride_queue_container').hasClass('shown')
          hideRideQueue()

      return
  ).fail (jqXHR) ->
      console.error jqXHR.responseText
      return
  return

$(document).on 'click', '.ride_detail', ->
  showRideDetail($(@).data('ride_hash'))
  return false
$(document).on 'click', '.ride_decline', ->
  declineRide($(@).data('ride_hash'))
  return false

$(document).on 'click', '#ride_queue_showhide', ->
  if $('#inner_ride_queue_container').hasClass('shown')
    hideRideQueue()
  else
    showRideQueue()
  return false

declineRide = (hash) ->
  $.ajax(
      url: '/ajax/decline_ride.script'
      type: 'POST'
      dataType: 'JSON'
      data:  
          ride_hash: hash
  ).done((data) ->
        console.log data
        mylert('Jízda odmítnuta!')
        reloadRideQueue()
        return
  ).fail (jqXHR) ->
      console.error jqXHR.responseText
      return

showRideDetail = (hash) ->
  $.ajax(
      url: '/ajax/show_ride_detail.script'
      type: 'POST'
      dataType: 'JSON'
      data:  
          ride_hash: hash
          
  ).done((data) ->
     
        console.log data

        $('#message .output').html ''
        $('#message .output').html data.html_output
        $('#message').addClass 'shown'
        $('#message').show()

        # if data.ride.ride.scheduled_start_lat

        #   showOnMap(drivers_map, data.ride.ride.scheduled_start_lat, data.ride.ride.scheduled_start_lng, 'start.png');
        #   showOnMap(drivers_map, data.ride.ride.scheduled_end_lat, data.ride.ride.scheduled_end_lng, 'end.png');

        return
  ).fail (jqXHR) ->
      console.error jqXHR.responseText
      return

checkPlannedRides = ->
    $.ajax(
        url: '/ajax/check_planned_ride.script'
        type: 'POST'
        dataType: 'JSON'
        data:  
            user: $('#user').val()
            
    ).done((data) ->
        console.log data
        if data.s > 0
            reloadRideQueue() 
        return
    ).fail (jqXHR) ->
        console.error jqXHR.responseText
        return
    
    
    return